import React from 'react'
import clsx from 'clsx'

const variants = {
  primary: 'bg-blue-600 text-white hover:bg-blue-500 shadow-sm',
  secondary: 'bg-slate-900 text-white hover:bg-slate-800',
  subtle: 'bg-white text-slate-700 border border-slate-200 hover:border-slate-300',
  ghost: 'text-slate-600 hover:text-slate-900'
}

const Button = ({ variant = 'primary', className, ...props }) => {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold transition',
        variants[variant],
        className
      )}
      {...props}
    />
  )
}

export default Button
